import { Link } from "react-router-dom";
import { ArrowRight, Clock, Tag } from "@phosphor-icons/react";
import type { BlogPost } from "../data/blog-posts";
import { formatDate } from "../data/blog-posts";

export function BlogCard({ post }: { post: BlogPost }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="card-snap group flex flex-col rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900/50 p-8"
    >
      <div className="flex flex-wrap items-center gap-2">
        {post.tags.map((tag) => (
          <span
            key={tag}
            className="inline-flex items-center gap-1 rounded-full bg-primary-500/5 dark:bg-primary-500/10 px-2.5 py-0.5 text-xs font-medium text-primary-500 dark:text-primary-300"
          >
            <Tag size={10} weight="bold" />
            {tag}
          </span>
        ))}
      </div>

      <h3 className="mt-4 text-xl font-semibold text-slate-900 dark:text-white group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors">
        {post.title}
      </h3>

      <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-500 dark:text-slate-400">
        {post.excerpt}
      </p>

      <div className="mt-6 flex items-center justify-between border-t border-slate-100 dark:border-slate-800 pt-4">
        <div className="flex items-center gap-4 text-xs text-slate-400 dark:text-slate-500">
          <span>{formatDate(post.date)}</span>
          <span className="inline-flex items-center gap-1">
            <Clock size={12} />
            {post.readTime}
          </span>
        </div>
        <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 dark:text-primary-400 opacity-0 group-hover:opacity-100 transition-opacity">
          Read
          <ArrowRight size={14} weight="bold" />
        </span>
      </div>
    </Link>
  );
}
